import { createContext, useContext, useRef } from 'react';

const BasisTheoryElementsContext = createContext({});

export const useBasisTheoryElementRefs = () => useContext(BasisTheoryElementsContext);

export const useBasisTheoryElementRefsProvider = () => {
  const cardRef = useRef(null);
  const routingNumberRef = useRef(null);
  const accountNumberRef = useRef(null);
  const accountHolderNameRef = useRef(null);

  return {
    Provider: BasisTheoryElementsContext.Provider,
    refs: { cardRef, routingNumberRef, accountNumberRef, accountHolderNameRef }
  };
};
